module.exports = __webpack_public_path__ + "img/1661274.99bcc947.png";